<template>
    <div>
        <div v-if="loading">
            <loading></loading>
        </div>

        <div v-else>
            <b-form-select
                v-model="accountingFirmCompanyId"
                :options="accountingFirmCompanies"
                class="col-4 mb-3"
                size="sm"
                @change="getData"
            />
            <b-alert variant="danger" :show="hasErrors">
                <span v-html="errorMessage"></span>
            </b-alert>
            <b-table
                responsive
                small
                :items="filteredItems"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="['search']"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                primary-key="client_id"
                @filtered="onFiltered"
            >
                <template #cell(jan)="data">
                    {{ formatNumber(data.item.jan) }}
                </template>
                <template #cell(feb)="data">
                    {{ formatNumber(data.item.feb) }}
                </template>
                <template #cell(mar)="data">
                    {{ formatNumber(data.item.mar) }}
                </template>
                <template #cell(apr)="data">
                    {{ formatNumber(data.item.apr) }}
                </template>
                <template #cell(may)="data">
                    {{ formatNumber(data.item.may) }}
                </template>
                <template #cell(jun)="data">
                    {{ formatNumber(data.item.jun) }}
                </template>
                <template #cell(jul)="data">
                    {{ formatNumber(data.item.jul) }}
                </template>
                <template #cell(aug)="data">
                    {{ formatNumber(data.item.aug) }}
                </template>
                <template #cell(sep)="data">
                    {{ formatNumber(data.item.sep) }}
                </template>
                <template #cell(oct)="data">
                    {{ formatNumber(data.item.oct) }}
                </template>
                <template #cell(nov)="data">
                    {{ formatNumber(data.item.nov) }}
                </template>
                <template #cell(dec)="data">
                    {{ formatNumber(data.item.dec) }}
                </template>
                <template #cell(year)="data">
                    {{ formatNumber(data.item.year) }}
                </template>
                <!-- FOOT -->
                <template #custom-foot="data">
                    <b-tr class="bg-light">
                        <b-th>TOTAL</b-th>
                        <b-th class="text-right">{{
                            formatNumber(total.jan)
                        }}</b-th>
                        <b-th class="text-right">{{
                            formatNumber(total.feb)
                        }}</b-th>
                        <b-th class="text-right">{{
                            formatNumber(total.mar)
                        }}</b-th>
                        <b-th class="text-right">{{
                            formatNumber(total.apr)
                        }}</b-th>
                        <b-th class="text-right">{{
                            formatNumber(total.may)
                        }}</b-th>
                        <b-th class="text-right">{{
                            formatNumber(total.jun)
                        }}</b-th>
                        <b-th class="text-right">{{
                            formatNumber(total.jul)
                        }}</b-th>
                        <b-th class="text-right">{{
                            formatNumber(total.aug)
                        }}</b-th>
                        <b-th class="text-right">{{
                            formatNumber(total.sep)
                        }}</b-th>
                        <b-th class="text-right">{{
                            formatNumber(total.oct)
                        }}</b-th>
                        <b-th class="text-right">{{
                            formatNumber(total.nov)
                        }}</b-th>
                        <b-th class="text-right">{{
                            formatNumber(total.dec)
                        }}</b-th>
                        <b-th class="text-right">{{
                            formatNumber(total.year)
                        }}</b-th>
                    </b-tr>
                </template>
            </b-table>
            <!-- Pagination -->
            <b-row>
                <b-col md="3" class="my-1 text-center">
                    <b-pagination
                        v-if="totalRows > 0"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        class="my-0"
                        size="sm"
                    ></b-pagination>
                </b-col>
                <b-col md="6" class="my-2">
                    <p class="text-center small pt-0">{{ legend }}</p>
                </b-col>
                <b-col md="3" class="my-1 text-right">
                    <b-dropdown
                        right
                        split
                        size="sm"
                        :text="perPage + ' éléments par page'"
                    >
                        <b-dropdown-item
                            v-for="pageOption in pageOptions"
                            :key="pageOption"
                            @click="setPerPage(pageOption)"
                        >
                            {{ pageOption }}
                        </b-dropdown-item>
                    </b-dropdown>
                </b-col>
            </b-row>
            <!-- /Pagination -->
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import loading from '../../../common/components/loading'
import TableHandler from '../../../common/mixins/TableHandler'
import DashboardHandler from '../../mixins/DashboardHandler'

export default {
    name: 'BudgetRollingActivity',

    components: {
        loading,
    },

    mixins: [TableHandler, DashboardHandler],

    data() {
        return {
            budgetType: 'all',
            accountingFirmCompanyId: 0,
            fields: [
                { key: 'activity_name', label: 'Activité', sortable: true },
                {
                    key: 'jan',
                    label: 'jan',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'feb',
                    label: 'fév',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'mar',
                    label: 'mar',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'apr',
                    label: 'avr',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'may',
                    label: 'mai',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'jun',
                    label: 'jun',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'jul',
                    label: 'jul',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'aug',
                    label: 'aoû',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'sep',
                    label: 'sep',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'oct',
                    label: 'oct',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'nov',
                    label: 'nov',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'dec',
                    label: 'déc',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'year',
                    label: 'TOTAL',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
            ],
            total: {},
        }
    },

    async created() {
        await this.getData()
    },

    methods: {
        async getData() {
            this.loading = true
            try {
                const response = await axios.get(
                    `/dashboard/budget/${this.accountingFirmCompanyId}/rolling-activity`
                )
                this.items = response.data.data
                this.calculateTotal()
                this.loading = false
            } catch (error) {
                console.log(error)
                this.handleErrors(error.response)
            }
        },

        initTotal() {
            this.total.jan = 0
            this.total.feb = 0
            this.total.mar = 0
            this.total.apr = 0
            this.total.may = 0
            this.total.jun = 0
            this.total.jul = 0
            this.total.aug = 0
            this.total.sep = 0
            this.total.oct = 0
            this.total.nov = 0
            this.total.dec = 0
            this.total.year = 0
        },

        calculateTotal() {
            this.initTotal()

            this.items.forEach((item) => (this.total.jan += item.jan))
            this.items.forEach((item) => (this.total.feb += item.feb))
            this.items.forEach((item) => (this.total.mar += item.mar))
            this.items.forEach((item) => (this.total.apr += item.apr))
            this.items.forEach((item) => (this.total.may += item.may))
            this.items.forEach((item) => (this.total.jun += item.jun))
            this.items.forEach((item) => (this.total.jul += item.jul))
            this.items.forEach((item) => (this.total.aug += item.aug))
            this.items.forEach((item) => (this.total.sep += item.sep))
            this.items.forEach((item) => (this.total.oct += item.oct))
            this.items.forEach((item) => (this.total.nov += item.nov))
            this.items.forEach((item) => (this.total.dec += item.dec))
            this.items.forEach((item) => (this.total.year += item.year))
        },

        formatNumber(number) {
            if (number === 0) {
                return '-'
            }
            if (number === null) {
                return '-'
            }
            return Math.floor(number).toLocaleString()
        },
    },

    computed: {
        ...mapState({
            year: (state) => state.browsing.year,
            accountingFirmCompanies: (state) =>
                state.data.options.accountingFirmCompanies,
        }),
    },
}
</script>

<style scoped></style>
